import main from './main';
 
export const endpoints = {
    main,
};

function getEndpoints (subdomain) {
    if (window.SUBDOMAIN_API && subdomain) {
        return endpoints[subdomain];
    }
    return endpoints.main;
}

export default getEndpoints;
